import injector from 'vue-inject'
import firebase from 'firebase/app'
import 'firebase/auth'
import jwt from 'jsonwebtoken'
import * as R from 'ramda'
import * as types from './mutation-types'
import { systemPermissions, userPermissionSettingList } from '@/common/constants/permissions'
import { storeClient } from '@/service/apiClients'

firebase.initializeApp({
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGING_SENDER_ID
})

export default store => {
  store.commit(`userModule/${types.SET_SIGN_IN_STATUS}`, injector.get('userSignInStatusType').processing)

  firebase.auth().onAuthStateChanged(async user => {
    if (user) {
      try {
        if (firebase.auth().currentUser) {
          const storeAccessToken = await storeClient.retrieveNewToken()
          store.commit(`userModule/${types.SET_USER_INFO}`, Object.assign({}, user, getPermissions(storeAccessToken)))
          store.commit(`userModule/${types.SET_SIGN_IN_STATUS}`, injector.get('userSignInStatusType').signedIn)
        }
      } catch (e) {
        store.commit(`userModule/${types.CLEAR_USER_INFO}`)
        store.commit(`userModule/${types.SET_SIGN_IN_STATUS}`, injector.get('userSignInStatusType').signedOut)
        console.error(e.message + ' at: user-plugin: signIn')
      }
    } else {
      store.commit(`userModule/${types.CLEAR_USER_INFO}`)
      store.commit(`userModule/${types.SET_SIGN_IN_STATUS}`, injector.get('userSignInStatusType').signedOut)
    }
  })

  storeClient.onTokenChanged(token => {
    store.commit(`userModule/${types.SET_USER_INFO}`, getPermissions(token))
  })

  store.subscribe(async mutation => {
    switch (mutation.type) {
      case 'userModule/' + types.SET_USER_INFO:
        try {
          if (mutation.payload.uid) {
            store.dispatch('userModule/getAllUserStores', mutation.payload.uid)
            store.dispatch('checkAppVersion', mutation.payload.uid)
          }
        } catch (e) {
          console.error(e)
        }
        break
      default:
    }
  })
}

function getPermissions (accessToken) {
  const scope = jwt.decode(accessToken).scope
  if (!scope) {
    return {
      permissions: {}
    }
  }
  return {
    permissions: Object.keys(scope).reduce((userPermissions, k) => {
      return R.assoc(
        k,
        userPermissionSettingList.reduce((ps, p) => R.assoc(p, !!(systemPermissions[p] & scope[k]), ps), {}),
        userPermissions
      )
    }, {})
  }
}
